<template>
  <div class="module-title" :class="type">
    <p class="title">{{title}}</p>
    <p v-show="sTitle" class="s_title">{{sTitle}}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    type: {
      type: String,
      default: 'dark'
    },
    sTitle: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="less" scoped>
  .module-title{
    font-size: 1.563vw;
    padding: 2.083vw 0;
    text-align: center;
    .title{
      font-size: 1.875vw;
      font-weight: 600;
      line-height: 5.208vw;
    }
    .s_title{
      line-height: 3.125vw;
      font-size: 1.042vw;
      color: #666666;
    }
  }
  .dark{
    color: #222;
    .s_title{
      color: #666666;
    }
  }
  .light{
    color: #fff;
    .s_title{
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/moduleTitle.vue